module.exports = __webpack_public_path__ + "static/media/blender.24f1b84b.jpg";